import { useMutation, useQueryClient } from '@tanstack/react-query';
import { makeBookingManagerApi } from 'services/BookingManagerApi';
import { IBankTransaction, IBankTransactionPatchRequest } from '../types';

interface ISaveDepositAccountParams {
  transactionUuid: string;
  payload: IBankTransactionPatchRequest;
}

/**
 * React Query mutation hook for saving deposit account information
 * to a bank transaction via PATCH endpoint.
 *
 * OWA-10228 / OWA-10342
 *
 * @returns Mutation object for saving deposit account
 */
export const useSaveDepositAccount = () => {
  const queryClient = useQueryClient();

  return useMutation<IBankTransaction, Error, ISaveDepositAccountParams>({
    mutationFn: async ({ transactionUuid, payload }: ISaveDepositAccountParams) => {
      const api = makeBookingManagerApi();
      const response = await api.patchBankTransaction(transactionUuid, payload);
      return response.data;
    },
    onSuccess: (_data, variables) => {
      // Invalidate the bank transaction query to refetch fresh data
      queryClient.invalidateQueries({
        queryKey: ['bankTransaction', variables.transactionUuid],
      });
    },
  });
};
